import { CallToAction } from "../_00Global/CallToAction";

export const _06CCTA = (): JSX.Element => {
  const handleContactClick = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="flex w-full justify-center items-center">
      <div className="flex flex-col w-[1440px] items-center justify-center relative">
        <CallToAction 
          className="!self-stretch !flex-[0_0_auto] !w-full" 
          arrowButtonText="Watch Our Videos"
          onClick={handleContactClick}
        />
      </div>
    </div>
  );
}; 